var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-multline",staticStyle:{"font-weight":"normal"}},[(_vm.consultaNaoConfirmada)?_c('div',{staticClass:"btns-actions"},[_c('confirmar-cancelar-consulta',{attrs:{"agenda":_vm.row},on:{"success":_vm.click}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }